import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import MasterKSU from "./components/MasterKSU";
import MasterHadiah from "./components/MasterHadiah";
import MasterBarangLain from "./components/MasterBarangLain";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";

class MasterLogistikNonMotor extends Component {
    contents = [
        {
            title: "KSU",
            component: <MasterKSU {...this.props} menuAccess={this.props.menuAccess}/>,
        },
        {
            title: "Hadiah",
            component: <MasterHadiah {...this.props} menuAccess={this.props.menuAccess}/>,
        },
        {
            title: "Barang Lain",
            component: <MasterBarangLain {...this.props} menuAccess={this.props.menuAccess}/>,
        }
    ];

    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        {this.contents.map((content, index) => (
                            <Tab
                                key={content.title + index}
                                id={`btn_navigate_${content.title}`}
                            >
                                {content.title}
                            </Tab>
                        ))}
                    </TabList>
                    {this.contents.map((content, index) => (
                        <TabPanel key={content.title + index}>{content.component}</TabPanel>
                    ))}
                </Tabs>
            </Container>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterLogistikNonMotor);